import {
  aCreateThresholdRule,
  aThresholdRule,
  mockCreateThresholdRuleBuilderOperationMutation,
} from '__generated__';

import { THRESHOLD_RULE_DATA } from '../queries/RuleBuilderQueryOperation.mocks';

export const handlers = [
  mockCreateThresholdRuleBuilderOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        createThresholdRule: aCreateThresholdRule({
          data: {
            ...aThresholdRule({ id: THRESHOLD_RULE_DATA.ruleId }),
            // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
            windowSizeMilliseconds:
              THRESHOLD_RULE_DATA.windowSizeInMilliseconds,
          },
        }),
      })
    );
  }),
];
